import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dot-loader',
  templateUrl: './dot-loader.component.html',
  standalone: true,
  imports: [],
})
export class DotLoaderComponent implements OnInit {
  type = input(1);
  class = input('tw-size-[1.25rem]');
  ngOnInit(): void {}
}
